export const DASHBOARD_WORKSPACE_STORAGE_KEY = 'inbiot.dashboard.workspace.v1'
export const DASHBOARD_WORKSPACE_VERSION = 1

export const clearDashboardWorkspace = () => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.sessionStorage.removeItem(DASHBOARD_WORKSPACE_STORAGE_KEY)
  } catch {}
}
